import templateUrl from "emun.invoice/inv/inv-details-actions.htm";

export default () => ({ templateUrl });
